export function getMatomoConfiguration() {
    const json = document.querySelector("#vue-matomo").innerText;
    const config = JSON.parse(json);
    return config;
}
